module.exports = __webpack_public_path__ + "img/about3.9d0102fc.jpg";